module.exports = __webpack_public_path__ + "static/img/cross.0ecdf69.png";


//////////////////
// WEBPACK FOOTER
// ./static/styles/mailkit/img/cross.png
// module id = fspQ
// module chunks = 1